<template>
  <div
    @mouseover="mouseEnter = true"
    @mouseleave="mouseEnter = false"
    class="temporary-position"
  >
    <md-card
      :class="[{ 'md-elevation-20': mouseEnter }]"
      class="snew-join-invitation-card"
    >
      <div class="card-header">
        <md-avatar class="little-header-avatar">
          <router-link :to="`/s-app/group-page/${request.groupId}`">
            <img src="../../../public/img/little-header-icons/portrait-group-header.png" alt="Group" />
          </router-link>
        </md-avatar>
        <span class="md-title">Moderator Change</span>
        <img src="../../../public/img/group-card-header.png" class="card-header-image" />
      </div>
      <md-card-content class="invitation-content">
        <div class="group-connection">
          <div class="row">
            <div class="col col-5 user-avatar">
              <router-link :to="`/s-app/profile-page/${request.sUserId}`">
                <SUserAvatar
                  :myUser="loggedUser"
                  size="large"
                  :isProfileAvatar="false"
                />
              </router-link>
            </div>
            <div class="col col-2 margin-arrow">
              <md-icon class="ml-2 mr-2" md-src="/svg-icons/arrowRight.svg" />
            </div>
            <div class="col col-5 group-avatar">
              <router-link :to="`/s-app/group-page/${request.groupId}`">
                <md-avatar class="md-large">
                  <img :src="getGroupImagePath(request.group)" alt="Group" />
                </md-avatar>
                <img class="moderator-badge" src="../../../public/svg-icons/moderatorBadge.png" alt="modecator icon" />
              </router-link>
            </div>
          </div>
        </div>

        <div class="group-connection-text">
          <div class="group-text">
            <p class="description-text">
              <span>
                <router-link :to="`/s-app/profile-page/${request.invitedById}`">
                  <span class="self-highlighted-word">{{ moderatorFirstName }}</span>
                </router-link>
                <span> is asking you to be the moderator for</span>
              </span>
            </p>
            <span>
              <router-link :to="`/s-app/group-page/${request.groupId}`">
                <p
                  class="description-text text-overflow self-highlighted-word mb-0"
                >
                  {{ request.group.name }}
                </p>
              </router-link>
              <p class="group-info">
                {{ this.getGroupPrivacy(request.group) }} | Zip
                {{ request.group.zip }}
              </p>
            </span>
          </div>
          <div class="accept-reject-request" v-if="showModeratorButtons">
            <div class="accept-btn">
              <md-button
                class="md-icon-button md-raised md-fab md-primary"
                @click.prevent="accept"
                :data-cy="`acceptInvitationBtn-${request.group.name}`"
              >
                <md-icon>done</md-icon>
              </md-button>
              <p>ACCEPT</p>
            </div>
            <div class="reject-btn">
              <md-button
                class="md-icon-button md-raised md-fab md-primary"
                @click.prevent="decline"
                :data-cy="`denyInvitationBtn-${request.group.name}`"
              >
                <md-icon>close</md-icon>
              </md-button>
              <p>DECLINE</p>
            </div>
          </div>
          <div class="message-moderator">
            <SButtonMaterial
              class="send-msg-item-btn"
              :md-ripple="false"
              buttonType="button"
              textColor="white"
              iconColor="secondary"
              iconWithoutText="chat"
              svgIcon="/svg-icons/purple-message-icon.svg"
              materialClass="dense"
              iconSize="2x"
              @button="openChat(request.group, getModerator.id)"
              :data-cy="`newItemChatButton-${getCurrentGroup.name}`"
            />
            <span>Message {{ moderatorFirstName }}</span>
          </div>
          <div
            class="accepted-action-user"
            v-if="accept_state == 'ACCEPTED'"
            data-cy="acceptedInvitationNotice"
          >
            <md-icon>check_circle</md-icon>
            <span class="action-notice">You accepted to be a moderator</span>
          </div>
          <div
            class="dennied-action-user"
            v-else-if="accept_state == 'DECLINED'"
            data-cy="declinedInvitationNotice"
          >
            <md-icon>cancel</md-icon>
            <span class="action-notice">You declined to be moderator</span>
          </div>
        </div>
      </md-card-content>
      <LoadingSpinner
        position="absolute"
        v-if="accept_state === 'PROCESSING'"
      />
    </md-card>
  </div>
</template>

<script>
import UserHelperVue from "@/mixins/UserHelper.vue";
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import CurrentUser from "@/mixins/CurrentUser.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import ChatHelperVue from '../../mixins/ChatHelper.vue';
export default {
  name: "SNewModeratorInvitationMaterial",
  props: ["request"],
  mixins: [UserHelperVue, GroupHelperVue, CurrentUser, ChatHelperVue],
  data() {
    return {
      accept_state: "WAITING_ACCEPT",
      mouseEnter: false,
      moderatorFirstName: "",
      joinResponse: null,
      requesting: false,
      setButtonTitle: "Send message",
      selectedKeyChat: {},
    };
  },
  components: {
    SButtonMaterial,
    LoadingSpinner,
    SUserAvatar,
  },
  computed: {
    groupName() {
      return this.request.group.name;
    },
    modalId() {
      return `-search-group-${this.request.groupId}`;
    },
    invitedByName() {
      return this.request.invitedBy?.firstName ?? null;
    },
    moderatorName() {
      return this.moderatorFirstName;
    },
    showModeratorButtons() {
      return (
        this.accept_state === "WAITING_ACCEPT" &&
        (this.request.hasInvitedByModerator ||
          this.request.hasInvitedByModerator === null ||
          this.getGroupPrivacy(this.request.group) === "Public")
      );
    },
    showNonModeratorNotice() {
      return (
        this.accept_state === "ACCEPTED" &&
        this.request.hasInvitedByModerator === false &&
        this.getGroupPrivacy(this.request.group) !== "Public"
      );
    },
    showNonModeratorButtons() {
      return (
        this.accept_state === "WAITING_ACCEPT" &&
        this.request.hasInvitedByModerator === false &&
        this.getGroupPrivacy(this.request.group) !== "Public"
      );
    },
  },
  methods: {
    openChat(key, member) {
      const selectedKeyId = key.id ?? key.group.id;
      const msgs = this.userMessages.some((msg) => {
        return msg.key.id === selectedKeyId;
      });
      if (!msgs) {
        this.selectedKeyChat = {
          key: key,
          messages: [],
          firstTalk: true,
        };
      } else {
        this.selectedKeyChat = this.userMessages.find((msg) => {
          return msg.key.id === selectedKeyId;
        });
        this.selectedKeyChat.messages = this.selectedKeyChat.messages.filter(
          (msg) => {
            return (
              msg.senderId === member.id || msg.receiverId === member.id
            );
          }
        );
      }
      this.selectedKeyChat = {
        ...this.selectedKeyChat,
        partner: member,
      };
      this.setPopupChat({
        isOpen: true,
        chatMsgs: this.selectedKeyChat,
      });
      this.$parent.$parent.$refs.rightStickyBar.openClosePopup();
    },
    async openModal() {
      await this.fetchModerator({ group: { id: this.request.groupId } });
      $(`#join-request${this.modalId}`).modal("show");
    },
    async accept() {
      this.accept_state = "PROCESSING";
      await this.fetchModerator({ group: { id: this.request.groupId } });
      await this.acceptModeratorInvitation(this.request.groupId);
      this.accept_state = "ACCEPTED";
      let postMsg = "Hi, I accepted to be moderator of the group " + this.request.group.name;
      await this.sendUserGroupMessageForModerator(this.getModerator.id, this.loggedUser, postMsg, this.request.groupId);
      this.$emit("membershipSituation");
      this.$parent.$parent.$refs.rightStickyBar.openClosePopup();
    },
    async decline() {
      await this.fetchModerator({ group: { id: this.request.groupId } });
      this.accept_state = "PROCESSING";
      await this.assignModeratorCancel({groupId: this.request.groupId, userId: this.request.sUserId})
      let postMsg = "Hi, I declined to be a moderator of the group " + this.request.group.name;
      await this.sendUserGroupMessageForModerator({id: this.getModerator.id}, this.loggedUser, postMsg, this.request.groupId);
      this.$emit("membershipSituation");
      this.accept_state = "DECLINED";
      this.$parent.$parent.$refs.rightStickyBar.openClosePopup();
    },
    resetModal() {
      this.setButtonTitle = "Send message";
      this.joinResponse = null;
      this.requesting = false;
    },
  },
  async created() {
    await this.fetchModerator({ group: { id: this.request.groupId } });
    this.moderatorFirstName = this.getModerator.firstName;
  },
};
</script>

// default card size
<style lang="scss" scoped>

  .message-moderator {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $secondary;
    font-weight: 500;
    font-size: 16px;
  }

  .message-moderator .md-button {
    min-width: unset;
    margin: unset;
    width: 67px;
    height: 67px;
  }

.moderator-badge {
  position: absolute;
  right: -12px;
  bottom: -7px;
  margin-right: unset !important; 
  min-width: unset !important; 
  max-width: unset !important;
  height: 37px; 
  width: 32px;
}
.snew-join-invitation-card {
  width: 344px;
  height: 558px;
  margin-bottom: 2rem;
  color: $black !important;
  border-radius: 4px;
  border: 1px solid $grey;
}
.md-title a {
  color: $black;
}
.md-title a:hover {
  color: $primary;
}
.col {
  padding: unset;
}
.margin-arrow {
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 0.1rem;
}
.group-avatar {
  padding-left: 0.55rem;
}
.user-avatar {
  padding-right: 0.55rem;
}
.description-text {
  font-family: "Roboto, sans-sefir";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  width: 250px;
  overflow-wrap: break-word;
  text-align: center;
  letter-spacing: 0.25px;

  .md-button {
    min-width: unset;
    width: 30px;
    height: 30px;
  }
}
.text-overflow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.card-header {
  height: 8%;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 10px;
  border: unset;
}
.card-header .md-avatar {
  min-width: unset;
  height: 24px;
  width: 24px;
  background-color: white;
  z-index: 2;
  margin: 0;
}
.card-header .md-title {
  font-weight: bold;
  margin-left: 10px;
  color: white;
  font-size: 14px;
  z-index: 2;
}
.card-header-image {
  height: 8%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 75%;
}
.little-header-avatar {
  border-radius: 0;
  background-color: #69287B !important;
}
</style>

<style lang="scss" scoped>
.invitation-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
}
.group-connection {
  margin-top: 1rem;
  margin-bottom: 2rem;
}
.group-connection i {
  color: $black !important;
}
.md-large {
  min-width: 100px !important;
  min-height: 100px !important;
}

.message-btn {
  min-width: unset;
  width: 36px;
  height: 36px;
}
.group-info,
.action-notice {
  font-family: "Roboto, sans-serif";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #000000;
  opacity: 0.6;
}
.action-notice {
  padding-left: 0.3rem;
}
.mb-0 {
  margin-bottom: unset;
}
.self-highlighted-word {
  font-weight: bold;
  color: #000000;
}
.group-connection-text {
  color: #000000;
  letter-spacing: 0.25px;
  .group-text {
    font-size: 20px;
    line-height: 26px;
  }
}
.group-text {
  display: flex;
  flex-direction: column;
  height: 130px;
  align-items: center;
  margin-left: 1.3rem;
  margin-right: 1.3rem;
}
.request-action-message {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 3rem;
  i {
    margin-top: 0.2rem;
  }
}
.open-chat {
  cursor: pointer;
  color: $secondary;
  font-size: 16px;
  display: flex;
  align-items: center;
  text-align: center;

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.open-chat:hover {
  color: $primary;
}
.accepted-action-user,
.dennied-action-user {
  word-break: break-all;
  margin: 4.5rem 0 0.1rem 0rem;
  text-align: center;
}
.accepted-action-user i {
  color: $primary !important;
}
.dennied-action-user i {
  color: $danger !important;
}
.center-text {
  text-align: center;
}
</style>

<style lang="scss">
  .accept-btn .md-icon-button .md-riple {
    background-color: $primary !important;
  }
  .reject-btn .md-icon-button .md-ripple {
    background-color: $danger !important;  
  }

  .accept-btn p {
    color: $primary;
    margin-top: 5px;
    font-weight: 500;
  }

  .reject-btn p {
    color: $danger;
    margin-top: 5px;
    font-weight: 500;
  }
.accept-reject-request {
  text-align: center;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 2rem !important;
  .md-button:last-child {
    margin-left: 12px;
  }
  i {
    color: $white !important;
  }
}
.accept-reject-request-non-moderator {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
}
</style>
